import {handleAction, handleSubState} from 'uix/actions'
import {persistReducer} from 'uix/persist'

import log from 'uix/logging'

import {setWikiPreview, setEditedWikiCode} from './actions'

export const data = [
  handleSubState(
    'wiki',
    [
      handleAction(setWikiPreview, ({preview, ...wiki}, {payload}) => ({
        ...wiki,
        preview: {...preview, [payload.storeKey]: payload.preview},
      })),
      persistReducer(
        handleAction(setEditedWikiCode, ({edited, ...wiki}, {payload}) => ({
          ...wiki,
          edited: {...edited, [payload.storeKey]: payload.text == undefined ? undefined : payload},
        })),
        {key: 'uix_wiki_code', whitelist: ['edited']}
      ),
    ],
    {preview: {}, edited: {}}
  ),
]
